import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const LargeAlertIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox='0 0 61 60' sx={{ width: '61px', height: '60px', ...sx }} {...props}>
      <svg width='61' height='60' viewBox='0 0 61 60'>
        <path
          d='M30.4994 22.5006V32.5006M30.4994 42.5006H30.5244M27.0377 9.72988L6.47547 45.2464C5.33496 47.2164 4.7647 48.2014 4.84898 49.0098C4.9225 49.7149 5.29192 50.3557 5.86532 50.7726C6.52271 51.2506 7.66087 51.2506 9.93718 51.2506H51.0616C53.3379 51.2506 54.4761 51.2506 55.1335 50.7726C55.7069 50.3557 56.0763 49.7149 56.1498 49.0098C56.2341 48.2014 55.6638 47.2164 54.5233 45.2464L33.9611 9.72988C32.8247 7.76697 32.2565 6.78552 31.5151 6.45588C30.8685 6.16835 30.1303 6.16835 29.4836 6.45588C28.7423 6.78552 28.1741 7.76697 27.0377 9.72988Z'
          stroke='black'
          strokeWidth='5'
          strokeLinecap='round'
          strokeLinejoin='round'
          fill={'transparent'}
        />
      </svg>
    </SvgIcon>
  );
};

export default LargeAlertIcon;
